/**
 * A chi si puo' mandare la sessione Limulo: SOLO a QBot di STAGING, giudicato sulla destinazione vera.
 *
 * 🔴 PERCHE' NON SI GIUDICA `env.qbotApiUrl` (revisione di #506, 2° giro, 🟡7). In dev quello e'
 * `/qbot-api`, il proxy Vite, che manda a `VITE_QBOT_API_URL || 'https://qbot.qlash.gg'`
 * (`vite.config.ts`) **da server a server**: nessun preflight CORS a fermare un header che arriva a
 * QBot di produzione. Vale con `vite --mode staging-prodtenant` e con un `.env.local` copiato da
 * `.env.example`, che dichiarano QBot di produzione.
 *
 * 🔑 LA GUARDIA NON USA IL LETTERALE DI PRODUZIONE — ed e' per questo che il letterale non va condiviso.
 * Si ammette solo `VITE_QBOT_API_URL` ESPLICITAMENTE uguale a QBot di staging (`env.qbotDestinationUrl`,
 * senza default): variabile assente ⇒ il proxy e il default di build vanno a produzione, e la guardia
 * dice no senza sapere dove vada. Un DEFAULT cambiato in `vite.config.ts` o in `env.ts` non puo' quindi far
 * passare la sessione. (Il letterale in `vite.config.ts` non e' importabile da `src/`: metterlo in due
 * progetti TS fa fallire `npx tsc --noEmit` con TS6305 prima di ogni build — il passo `typecheck` della CI.)
 *
 * ⚠️ MA «quando la variabile c'e' client e proxy leggono la stessa» e' vero SOLO se leggono lo stesso `.env`:
 * il client lo legge dalla root di Vite, il proxy da `process.cwd()`. Con `vite --root <wt>` lanciato da
 * un'altra cartella il client vede `stg-qbot` e il proxy legge altro (misurato dalla revisione di #506, 3°
 * giro). Per questo la difesa sta ANCHE nel proxy (`vite.config.ts`, `proxyReq`), dove la destinazione si
 * decide: la guardia qui sopra e' la prima linea, non l'unica.
 */

/** L'unico host a cui la sessione Limulo puo' andare: QBot di STAGING. */
export const QBOT_STAGING_HOST = 'stg-qbot.qlash.gg';

/**
 * `true` SOLO se `destinazione` e' QBot di staging: `https` e host esattamente `stg-qbot.qlash.gg`.
 *
 * Ammette, non esclude: un host che non riconosce (produzione, un typo, `http`, `:8443` a un altro
 * host, una stringa vuota, un URL relativo, una stringa che non e' un URL) NON riceve la sessione.
 */
export function qbotRiceveLaSessioneLimulo(destinazione: string): boolean {
  try {
    const url = new URL(destinazione.trim());
    return url.protocol === 'https:' && url.hostname === QBOT_STAGING_HOST;
  } catch {
    return false;
  }
}
